import ListadoBancos from "./ListadoBancos.jsx";
import { connect } from "react-redux";
import { actions } from "../../../../../redux/modules/bancos/bancos";

const ms2p = (state) => {
    return {
        ...state.bancos,
    };
};

const md2p = { ...actions };

export default connect(ms2p, md2p)(ListadoBancos);
